// extracted by mini-css-extract-plugin
export var section = "post-list-module--section--QBS7j";
export var container = "post-list-module--container--rz1iR";
export var containerText = "post-list-module--containerText--MInI4";
export var containerBottom = "post-list-module--containerBottom--nUKtF";
export var postItem = "post-list-module--postItem--Sawb3";